// Query serialization, in one place so no call site hand-builds a URL.
// `undefined` and `null` params are omitted rather than serialized as the
// strings "undefined"/"null" - which matters for the documented optional
// params (statistics `widgetType`), where an absent filter and a filter with
// the literal value "undefined" mean very different things to a backend.
export function buildUrl(baseUrl, path, query) {
  const url = `${baseUrl}${path}`;
  if (!query) return url;

  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(query)) {
    if (value === undefined || value === null || value === '') continue;
    params.append(key, String(value));
  }

  const serialized = params.toString();
  return serialized ? `${url}?${serialized}` : url;
}
